
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 20 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9.999 10.835a.833.833 0 100-1.667.833.833 0 000 1.667zM15.832 10.835a.833.833 0 100-1.667.833.833 0 000 1.667zM4.165 10.835a.833.833 0 100-1.667.833.833 0 000 1.667z","stroke":"currentColor","stroke-width":"1.667","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    